<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import { ssologion } from '@/api/user'
export default {
  name: 'App',
  created(){
      var _hmt = _hmt || [];
      (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?b952b1b1844ef53a765da8e3872e23ea";
        var s = document.getElementsByTagName("script")[0]; 
        s.parentNode.insertBefore(hm, s);
      })();
        }
      }
</script>
<style>
#app{
  height:100% !important;
}
</style>

